// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".roles[data-v-75e08b6d]{display:flex;flex-wrap:wrap;margin-bottom:-10px}.roles .role[data-v-75e08b6d]{margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
